import $ from 'jquery';
import rivets from 'rivets';
import BaseView from '../../core/baseView';
import ItalianTaxId from '../../layout/italianTaxId';

export default BaseView.extend({

    events: {
        'blur input, select': 'onBlur',
        'submit .js-register-form-private': 'onRegisterPrivateCustomerSubmit'
    },

    selectors: {
        taxId: '.js-tax-id input'
    },

    initialize: function () {
        this.$taxId = this.$el.find(this.selectors.taxId);

        if (this.$taxId) {
            this.taxId = new ItalianTaxId({
                el: this.$taxId
            });
        }

        this.setupRivetsBindings();
        this.bindEvents();
    },

    bindEvents: function () {
        if (this.$taxId.length) {
            this.listenTo(this.model.get('form'), 'change:showTaxId', this.onShowTaxId, this);
        }
    },

    setupRivetsBindings: function () {
        rivets.bind(this.$el, {
            viewModel: this.model
        });
    },

    onBlur: function (e) {
        var name = e.target.name;
        var $fields = this.$el.find('[name="' + name + '"]').not($(e.target));

        if ($fields.length) {
            $fields.valid();
        }
    },

    onRegisterPrivateCustomerSubmit: function () {
        this.removeCompanyFromPrivateCustomer();
    },

    removeCompanyFromPrivateCustomer: function () {
        const formModel = this.model.get('form');
        const isPrivateCustomer = !formModel.get('showBusinessForm');

        if (isPrivateCustomer) {
            formModel.set('company', '');
        }
    },

    onShowTaxId: function (model, value) {
        if (this.$taxId) {
            this.$taxId.attr('data-validate', value);
        }
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/login/registerFormPrivateCustomerView.js
 **/